<template>
  <main id="home">
    <hero/>
  </main>
</template>

<style lang="scss" scoped>
  @import '../styles/pages/home.scss';
</style>

<script>
// @ is an alias to /src
import hero from '@/components/hero.vue';

export default {
  name: 'Home',
  components: {
    hero
  },
};
</script>
